// login.component.ts

import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AuthService } from '../../_service/auth.service';
import { UserSettingsService } from '../../_service/user-settings.service';


@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'], // Optional: Include if you have styles
    imports: [CommonModule, FormsModule, RouterModule]
})



export class LoginComponent implements AfterViewInit{
    @ViewChild('usernameInput') usernameInput!: ElementRef;

  username: string = '';
  password: string = '';
  errorMessage: string = '';
  loading: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private userSettingsService: UserSettingsService
  ) { }


  ngAfterViewInit(): void {
    this.userSettingsService.loadSavedTheme();
    this.usernameInput.nativeElement.focus();
  }


  /**
   * Handles the login process by calling the AuthService login method.
   * Navigates to the home page upon successful login.
   */
  onLogin(): void {
    console.log("in onLogin()");

    this.loading = true;
    this.authService.login(this.username, this.password).subscribe(
      response => {
        this.loading = false;
        // Navigate to the home page
        this.router.navigate(['/home']);
      },
      error => {
        this.loading = false;
        // Display error message
        // this.errorMessage = error;
        this.setErrorMessage(error);
      }
    );
  }


  /**
   * Sets a user-friendly error message based on the error response.
   * @param error The error response from the login attempt.
   */
  private setErrorMessage(error: any): void {
    console.error('In login.component.ts: setErrorMessage() : ', error); // Log the entire error object
    this.errorMessage = error;
    // const status = error.response?.status || error.status;
    // if (status === 401) {
    //   this.errorMessage = 'Invalid username or password. Please try again.';
    // } else if (status === 0) {
    //   this.errorMessage = 'Unable to connect to the server. Please check your internet connection.';
    // } else {
    //   this.errorMessage = 'An unexpected error occurred. Please try again later.';
    // }
  }



}